// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1P61p","list__item":"styles_list__item__ZM_Qc"};